import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "section",
  id: "portfolio"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "section-heading" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "title is-2" }, "Portfólio"),
  /*#__PURE__*/_createElementVNode("h4", { class: "subtitle is-5" }, "Meus últimos trabalhos")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MyProjetos = _resolveComponent("MyProjetos")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_MyProjetos)
    ])
  ]))
}